
import ClubRuleBase from "./club_rule_base";
import ClubGameInfo from "../component/club_game_info";
import LanguageManager from "../../../manager/language_manager";


const {ccclass, property} = cc._decorator;

@ccclass
export default class ClubRuleMgrView extends ClubRuleBase {


    onLoad(){

    }

  

    public createItems(dataList : any[]){
        super.createItems(dataList);

        dataList.forEach((data,index)=>{
            
            let infoItem = this.itemList[index].getComponent(ClubGameInfo);

            infoItem.refresh();        
        })
    }
    


 
}
